import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./iconGrid.css";

import icon1 from "../assets/icons/icon-01.png";
import icon2 from "../assets/icons/icon-02.png";
import icon3 from "../assets/icons/icon-03.png";
import icon4 from "../assets/icons/icon-04.png";
import icon5 from "../assets/icons/icon-05.png";
import icon6 from "../assets/icons/icon-06.png";
import icon7 from "../assets/icons/icon-07.png";
import icon8 from "../assets/icons/icon-08.png";
import icon9 from "../assets/icons/icon-09.png";
import icon10 from "../assets/icons/icon-10.png";
import icon11 from "../assets/icons/icon-11.png";
import icon12 from "../assets/icons/icon-12.png";
import icon13 from "../assets/icons/icon-13.png";
import icon14 from "../assets/icons/icon-14.png";
import icon15 from "../assets/icons/icon-15.png";
import icon16 from "../assets/icons/icon-16.png";
import icon17 from "../assets/icons/icon-17.png";
import icon18 from "../assets/icons/icon-18.png";
import icon19 from "../assets/icons/icon-19.png";


const items = [
    { icon: icon1, title: "Shirts" },
    { icon: icon2, title: "Pants" },
    { icon: icon3, title: "Baniyan" },
    { icon: icon4, title: "Turban Cap" },
    { icon: icon5, title: "Umbrella" },
    { icon: icon6, title: "Big Bag" },
    { icon: icon7, title: "Mobile Phone" },
    { icon: icon8, title: "Smart Glasses" },
    { icon: icon9, title: "Headset" },
    { icon: icon10, title: "Idols" },
    { icon: icon11, title: "Charger" },
    { icon: icon12, title: "Camera" },
    { icon: icon13, title: "Laptop" },
    { icon: icon14, title: "Pendrive" },
    { icon: icon15, title: "Tablet PC" },
    { icon: icon16, title: "Smart Watch" },
    { icon: icon17, title: "Helmet" },
    { icon: icon18, title: "Remote Key" },
    { icon: icon19, title: "Gadgets" },
];


const itemContainerVariants = {

    hidden: {},

    visible: {
        transition: {
            staggerChildren: 0.06,
        },
    },

};


const itemVariants = {

    hidden: {
        opacity: 0,
        y: 25,
        scale: 0.94,
    },

    visible: {
        opacity: 1,
        y: 0,
        scale: 1,

        transition: {
            duration: 0.4,
            ease: "easeOut",
        },
    },

};


function IconGrid() {

    const [isOpen, setIsOpen] = useState(false);


    return (

        <section className="not-allowed-section">


            {/* =========================================
                MAIN SERVICE BOX
            ========================================= */}

            <motion.button
                className={`not-allowed-service ${
                    isOpen ? "service-open" : ""
                }`}

                onClick={() => setIsOpen(!isOpen)}

                whileHover={{
                    y: -5,
                }}

                whileTap={{
                    scale: 0.98,
                }}
            >

                {/* Icon */}

                <div className="not-allowed-main-icon">

                    <span className="main-icon-ring"></span>

                    <i className="fa fa-ban"></i>

                </div>


                {/* Content */}

                <div className="not-allowed-main-content">

                    <span className="service-label">
                        TEMPLE GUIDELINES
                    </span>

                    <h2 style={{fontFamily:'Montserrat'}}>
                        Not Allowed inside the Temple Premises
                    </h2>

                    <p>
                        Please check the list of items that are
                        not permitted inside the temple.
                    </p>

                </div>


                {/* Count */}

                <div className="not-allowed-count">

                    <strong>
                        {items.length}
                    </strong>

                    <span>
                        Items
                    </span>

                </div>


                {/* Arrow */}

                <motion.div
                    className="not-allowed-expand"
                    animate={{
                        rotate: isOpen ? 180 : 0,
                    }}
                    transition={{
                        duration: 0.3,
                    }}
                >

                    <i className="fa fa-chevron-down"></i>

                </motion.div>

            </motion.button>


            {/* =========================================
                SUB ITEMS
            ========================================= */}

            <AnimatePresence>

                {isOpen && (

                    <motion.div
                        className="not-allowed-items"
                        variants={itemContainerVariants}
                        initial="hidden"
                        animate="visible"
                        exit={{
                            opacity: 0,
                            y: -15,
                            transition: {
                                duration: 0.25,
                            },
                        }}
                    >

                        {items.map((item, index) => (

                            <motion.div
                                className="not-allowed-card"
                                key={index}
                                variants={itemVariants}

                                whileHover={{
                                    x: 5,
                                    scale: 1.01,
                                }}
                            >

                                {/* Number */}

                                <div className="not-allowed-number">

                                    {String(index + 1).padStart(2, "0")}

                                </div>


                                {/* Icon */}

                                <div className="not-allowed-icon">

                                    <img
                                        src={item.icon}
                                        alt={item.title}
                                    />

                                </div>


                                {/* Name */}

                                <div className="not-allowed-content">

                                    <h4>
                                        {item.title}
                                    </h4>

                                    <span>
                                        Not permitted
                                    </span>

                                </div>


                                {/* Arrow */}

                                <div className="not-allowed-arrow">

                                    <i className="fa fa-angle-right"></i>

                                </div>

                            </motion.div>

                        ))}

                    </motion.div>

                )}

            </AnimatePresence>


        </section>
    );
}


export default IconGrid;